import React from 'react'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import img1 from '../../images/ASP_AMEN1.webp'
import img2 from '../../images/Basketball.webp'
import img3 from '../../images/GYM-1.webp'
import img4 from '../../images/ASP_AMEN2.webp'
import img5 from '../../images/ASP_AMEN3.webp'
import img6 from '../../images/ASP_AMEN4.webp'

const MobileGallery = () => {
    const data = [
        {
            "id": 1,
            "image": img1
        },
        {
            "id": 2,
            "image": img2
        },
        {
            "id": 3,
            "image": img3
        },
        {
            "id": 4,
            "image": img4
        },
        {
            "id": 5,
            "image": img5
        },
        {
            "id": 6,
            "image": img6
        },
        {
            "id": 7,
            "image": "/amenitiesmobile1.png"
        },
        {
            "id": 8,
            "image": "/amenitiesmobile2.png"
        },
        {
            "id": 9,
            "image": "/amenitiesmobile3.png"
        },
        {
            "id": 10,
            "image": "/amenitiesmobile4.png"
        }
    ];
    // console.log("data", data?.slice(0,5))
    return (
        <div className='mobile-gallery-section mt-7 m-50'>
            <Carousel
                additionalTransfrom={0}
                arrows={false}
                autoPlaySpeed={3000}
                autoPlay={true}
                centerMode={false}
                // customTransition="all .5"
                // transitionDuration={500}
                className="m-50"
                // containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={true}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                partialVisible
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                    desktop: {
                        breakpoint: {
                            max: 3000,
                            min: 1024
                        },
                        items: 3,
                        partialVisibilityGutter: 40
                    },
                    mobile: {
                        breakpoint: {
                            max: 464,
                            min: 0
                        },
                        items: 1,
                        partialVisibilityGutter: 90
                    },
                    tablet: {
                        breakpoint: {
                            max: 1024,
                            min: 464
                        },
                        items: 2,
                        partialVisibilityGutter: 30
                    }
                }}
                rewind={true}
                rewindWithAnimation={false}
                rtl={false}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {data?.slice(0,5).map((ele, i) => {
                    return (
                        <img key={i} src={ele.image} alt="" className='img-fluid w-100' style={{ cursor: 'pointer', maxWidth: '90%', borderRadius: '11px' }} />
                    )
                })
                }
            </Carousel>
            <Carousel
                additionalTransfrom={0}
                arrows={false}
                autoPlaySpeed={3000}
                autoPlay={true}
                centerMode={false}
                // customTransition="all .5"
                // transitionDuration={500}
                className=""
                // containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={true}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                partialVisible
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={{
                    desktop: {
                        breakpoint: {
                            max: 3000,
                            min: 1024
                        },
                        items: 3,
                        partialVisibilityGutter: 40
                    },
                    mobile: {
                        breakpoint: {
                            max: 464,
                            min: 0
                        },
                        items: 1,
                        partialVisibilityGutter: 90
                    },
                    tablet: {
                        breakpoint: {
                            max: 1024,
                            min: 464
                        },
                        items: 2,
                        partialVisibilityGutter: 30
                    }
                }}
                rewind={true}
                rewindWithAnimation={false}
                rtl={true}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {data?.slice(5, 10).map((ele, i) => {
                    return (
                        <img key={i} src={ele.image} alt="" className='img-fluid w-100' style={{ cursor: 'pointer', maxWidth: '90%', borderRadius: '11px' }} />
                    )
                })
                }
            </Carousel>
        </div>
    )
}

export default MobileGallery
